// 自定义缓存实例池id
// export const CACHE_CUSTOM_INSTANCE_ID = 'CACHE_INSTANCE_ID_' + Date.now();

// 用户列表缓存key
export const CACHE_USER_LIST = 'USER_LIST';

